export const validateDbtSelector = (selector) => 
// eslint-disable-next-line no-useless-escape
/^@?[a-zA-Z0-9\s\*\-\.\+:_\/]+$/.test(selector);
//# sourceMappingURL=dbt.js.map